import React, { FC, useState } from 'react';
import { MuiColorInput } from 'mui-color-input';

interface ColorPickerProps {
    name: string;
    view: boolean;
    color?: string;
    handleColorPicker: (name: string, value: string) => void;
}

const ColorPicker: FC<ColorPickerProps> = ({ name, view = false, color, handleColorPicker }) => {

    const [value, setValue] = useState<string>(color || '#8D97A0');

    const handleChange = (newValue: string) => {
        setValue(newValue);
        handleColorPicker(name, newValue);
    }

    return (
        <div className='position-relative mt-2'>
            <div
                className='position-absolute bg-white'
                style={{ fontSize: '12px', top: -8, left: 10, zIndex: 10, padding: '0 5px', color: '#1976D2' }}
            >
                Color
            </div>
            <MuiColorInput
                className='w-100'
                format="hex"
                value={value}
                disabled={view}
                onChange={handleChange}
                sx={{
                    '& .MuiInputBase-root': {
                        borderColor: '#1976D2',
                    },
                    '& .MuiInputBase-root:hover': {
                        borderColor: '#1565C0',
                    },
                }}
            />
        </div>
    );
}

export default ColorPicker;
